"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimGuildQuestResponseToJSON = exports.ClaimGuildQuestResponseFromJSONTyped = exports.ClaimGuildQuestResponseFromJSON = void 0;
var _1 = require("./");
function ClaimGuildQuestResponseFromJSON(json) {
    return ClaimGuildQuestResponseFromJSONTyped(json, false);
}
exports.ClaimGuildQuestResponseFromJSON = ClaimGuildQuestResponseFromJSON;
function ClaimGuildQuestResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'rewards': (json['rewards'].map(_1.RewardResponseObjectFromJSON)),
    };
}
exports.ClaimGuildQuestResponseFromJSONTyped = ClaimGuildQuestResponseFromJSONTyped;
function ClaimGuildQuestResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'rewards': (value.rewards.map(_1.RewardResponseObjectToJSON)),
    };
}
exports.ClaimGuildQuestResponseToJSON = ClaimGuildQuestResponseToJSON;
